export default "__VITE_ASSET__uANrrZM4__"